import { create } from 'zustand';

import {
  ENDPOINT_FARMER_CONTRACTS,
  ENDPOINT_FARMER_CONTRACTS_BY_RECEPTION_SLUG,
  ENDPOINT_GRAIN_RECEPTION_MANAGE_FARMER_CONTRACT,
  ENDPOINT_RECEPTION,
  ENDPOINT_RECEPTIONS_MANAGE_FARMER_CONTRACT,
} from '@/common/constants';
import { HttpApi } from '@/common/http';
import { IFarmerContract, IMeasureAction, IMeasureState } from '../models';
import { MeasureState } from './state';

const httpApi = new HttpApi();

export interface IImageUploadResponse {
  id: string;
  error_file_id: string;
  status?: string;
}

const useMeasureStore = create<IMeasureState & IMeasureAction>((set) => ({
  ...MeasureState,
  isManageGrainContractLoading: false,
  setLoad: (load) => set({ load }),

  fetchFarmer: async (stir: number) => {
    const response = await httpApi.get<IFarmerContract[]>(
      `${ENDPOINT_FARMER_CONTRACTS}/${stir}`,
    );

    return {
      name: response?.at(0)?.name!,
      contracts: response,
    };
  },
  fetchFarmerContracts: async (reception_id: string) => {
    const response = await httpApi.get<IFarmerContract[]>(
      ENDPOINT_FARMER_CONTRACTS_BY_RECEPTION_SLUG.replace(
        '{slug}',
        reception_id,
      ),
    );
    set({ contractList: response });
    return response;
  },

  manageContract: async (data, id) => {
    set({ isManageContractLoading: true });
    try {
      const res = await httpApi.put(
        ENDPOINT_RECEPTIONS_MANAGE_FARMER_CONTRACT.replace('{id}', id!),
        data,
      );
      return res;
    } finally {
      set({ isManageContractLoading: false });
    }
  },
  manageGrainContract: async (data, id) => {
    set({ isManageGrainContractLoading: true });
    try {
      const res = await httpApi.put(
        ENDPOINT_GRAIN_RECEPTION_MANAGE_FARMER_CONTRACT.replace('{id}', id!),
        data,
      );
      return res;
    } finally {
      set({ isManageGrainContractLoading: false });
    }
  },
  saveReception: async (data) => {
    set({ receptionLoading: true });
    try {
      const res = await httpApi.post(ENDPOINT_RECEPTION, data);
      set({ load: res });
      return res;
    } finally {
      set({ receptionLoading: false });
    }
  },
}));

export default useMeasureStore;
